import { baseService } from 'modules/baseService';
import HttpClient from 'services/HttpClient';
import { Week } from 'models/Week';

const baseUrl = '/quests';

export const getAvailableWeeks = baseService<{ questId: string }, Week[]>(
  ({ questId }) => HttpClient.get(`${baseUrl}/${questId}/weeks`),
);
